import { render, staticRenderFns } from "./ReportVisits.vue?vue&type=template&id=8f5ae9b6"
import script from "./ReportVisits.vue?vue&type=script&lang=js"
export * from "./ReportVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports